<div class="px-4 b-b pb-2 mb-4" scroll-top-on-condition='true'>
    <div class="row justify-content-between align-v-center">
        <h5 class="medium mb-0">Edit Notification lang</h5>
        <button class="btn btn-secondary" (click)='cancelEdit()'><i class="fa fa-arrow-left mr-2"></i> Back
        </button>
    </div>
</div>

<div class="card mb-4">
    <div class="card-header">Basic details</div>
    <div class="card-body p-3 row">
        <div class="col-6">
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" rows="5" [(ngModel)]="notificationLang.name"/>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <label>Description</label>
                <input type="text" class="form-control" rows="5" [(ngModel)]="notificationLang.description"/>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label>Subject template</label>
                <textarea class="form-control" rows="2" [(ngModel)]="notificationLang.subjectTemplate">
                </textarea>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group">
                <label>Locale</label>
                <select class="form-control" id='locale' [(ngModel)]="notificationLang.locale">
                    <option *ngFor="let locale of locals;index as i" value='{{locale.locale}}'>{{locale.name}}</option>
                </select>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <label>Message template</label>
                <div class="w-100 float-left rich-text-editor">
                    <quill-editor [(ngModel)]='notificationLang.messageTemplate'>
                        <div quill-editor-toolbar>
                            <span class="ql-formats">
                                <button class="ql-bold" [title]="'Bold'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-italic" [title]="'italic'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-underline" [title]="'Underline'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" [title]="'list'" value="ordered">
                                </button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" [title]="'list'" value="bullet">
                                </button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" [title]="'list'" value="check">
                                </button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-header" [title]="'header'" value="1">
                                </button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-header" [title]="'header'" value="2">
                                </button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-blockquote" [title]="'blockquote'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-formula" [title]="'formula'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-link" [title]="'link'"></button>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-code-block" [title]="'code-block'"></button>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-font" [title]="'font'">
                                    <option value="sans serif"></option>
                                    <option value="serif"></option>
                                    <option value="monospace"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-color" [title]="'color'">
                                    <option value="white"></option>
                                    <option value="black"></option>
                                    <option value="red"></option>
                                    <option value="blue"></option>
                                    <option value="green"></option>
                                    <option value="lightblue"></option>
                                    <option value="orange"></option>
                                    <option value="pink"></option>
                                    <option value="yellow"></option>
                                    <option value="purple"></option>
                                    <option value="grey"></option>
                                    <option value="lightgreen"></option>
                                    <option value="lightyellow"></option>
                                    <option value="magenta"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-background" [title]="'background'">
                                    <option value="white"></option>
                                    <option value="black"></option>
                                    <option value="red"></option>
                                    <option value="blue"></option>
                                    <option value="green"></option>
                                    <option value="lightblue"></option>
                                    <option value="orange"></option>
                                    <option value="pink"></option>
                                    <option value="yellow"></option>
                                    <option value="purple"></option>
                                    <option value="grey"></option>
                                    <option value="lightgreen"></option>
                                    <option value="lightyellow"></option>
                                    <option value="magenta"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-size" [title]="'font'">
                                    <option value="small"></option>
                                    <option value="large"></option>
                                    <option value="huge"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-align" [title]="'Aligment'">
                                    <option selected></option>
                                    <option value="center"></option>
                                    <option value="right"></option>
                                    <option value="justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-strike" [title]="'strike'"></button>
                            </span>
                        </div>
                    </quill-editor>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="px-3 mb-3">
    <button class="btn btn-success float-right ml-3" (click)='saveData()'>Save</button>
    <button class="btn btn-secondary float-right" (click)='cancelEdit()'>Cancel</button>
</div>



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/editNotificationLangComponent.html